import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const PlanContext = createContext(null);

export function PlanProvider({ children }) {
  const [plan, setPlan] = useState(null);
  const { pathname } = useLocation();

  const load = useCallback(async () => {
    try {
      const { data } = await api.plan();
      setPlan(data);
    } catch {
      setPlan(null);
    }
  }, []);

  useEffect(() => { load(); }, [load, pathname]);

  const value = useMemo(() => ({ plan, reloadPlan: load }), [plan, load]);
  return <PlanContext.Provider value={value}>{children}</PlanContext.Provider>;
}

export function usePlan() {
  return useContext(PlanContext) || { plan: null, reloadPlan: () => {} };
}

export function usePlanLimit(resource) {
  const { plan } = usePlan();
  const state = plan?.resources?.[resource];
  if (!state?.reached) return { reached: false, hint: "" };
  const label = state.limit === 1 ? state.label_one : state.label;
  return {
    reached: true,
    hint: `Limite del piano ${plan.plan_name} raggiunto: ${state.limit} ${label} su ${state.limit}. Passa a un piano superiore da "Piano e limiti" per aggiungerne altri.`,
  };
}
